import { Observable } from 'rxjs';
import { IBaseService } from '@pit/core';
import { IDtoUser } from '@pit/frontend-model';

export interface ICronDataService extends IBaseService {

    forceArchiveBuild$(): Observable<boolean>;
    forceArchiveBuildAsync(): Promise<boolean>;

    forceArchiveClean$(): Observable<boolean>;
    forceArchiveCleanAsync(): Promise<boolean>;

    forceTransferToCul$(): Observable<boolean>;
    forceTransferToCulAsync(): Promise<boolean>;

}

